import {
    LinearProgress,
    TextField,
    Select, MenuItem
} from '@material-ui/core';

import {
    NavigationOptionsProps
} from '../types';

import React, { useEffect, useState } from 'react';

import { screens, ScreenAPI } from '../../widgets/constants';
import styles from './styles.module.scss';
import { stores } from 'mobx-store';

export const NavigationOptions: React.FC<NavigationOptionsProps> = (props: NavigationOptionsProps) => {
    const {
        customScreens,
    } = stores.customScreenStore.Stores;

    const [subScreens, setSubScreens] = useState<{id: string, title: string}[]>([]);
    const [loadingScreens, setLoadingScreens] = useState<boolean>(false);

    useEffect(
        () => {
            selectedScreenChange(props.redirect);
        },
        [],
      );
      
    const selectedScreenChange = (name: string) => {
        props.handleEntityIdChangeData(name);
        const screen = screens.find(screen => screen.name === name);
        setSubScreens([]);
        if (screen && screen.api) {
            getSubScreensList(screen.api);
        }
    };
    const selectedSubScreen = (subScreenId: string) =>{
        props.handleRedirectChangeData(subScreenId);
    };
    const getSubScreensList = async (api: ScreenAPI) => {
        try {
            setLoadingScreens(true);
            await customScreens.getScreensList(api);
            setSubScreens(customScreens.screensList);
        } catch (error) {
         console.log(error);   
        } finally {
            setLoadingScreens(false);
        }
    };
    return (
        <div className={styles.navigationsOptions}>
           {!props.hideRedirect && <div className={styles.item}>
                <Select
                    onChange={(event) => selectedScreenChange(event.target.value as ScreenAPI)}
                    value={props.redirect || ''}
                >
                    {
                        screens.map(screen => <MenuItem key={screen.name} value={screen.name}>{screen.name}</MenuItem>)
                    }
                </Select>
            </div>}
            <div className={styles.item}>
                {
                    subScreens.length > 0 &&
                    <Select
                        onChange={(event) => selectedSubScreen(event.target.value as string)}
                        value={props.entityId || ''}
                    >
                    {
                        subScreens.map(subScreen => <MenuItem value={subScreen.id}>{subScreen.title}</MenuItem>)
                    }
                    </Select>
                }
                {
                    loadingScreens && <LinearProgress />

                }

            </div>
        </div>
    )
};